import * as React from 'react';
import PipelineVisualStore from '../../stores/PipelineVisualStore';
import ParametersCustomModelSelect from './ParametersCustomModelSelect';
import { Props } from './types';

const ParametersCustomEmbeddingModelSelect: <T extends PipelineVisualStore<S>, S extends string>(
    props: Props<T, S>
) => React.ReactElement<Props<T, S>> = props => <ParametersCustomModelSelect {...props} modelType="embedding" />;

export default ParametersCustomEmbeddingModelSelect;
